export const PHONE_REG_EXP_REQUIRED = /^(0[1-9][0-9]{7,8}|[0-9]{4})$/;
export const PHONE_REG_EXP_NOT_REQUIRED = /^$|^(0[1-9][0-9]{7,8}|[0-9]{4})$/;
export const SPECIAL_CHAR = /[!@#$%^&*(),.?":{}|<>]/;
export const TAX_ID_REG_EXP = /^\d{13}$|^(?![\s\S])/;
export const DUPLICATE_KEY_ERROR_REGEX = /duplicate key value/;
export const BANK_ACCOUNT_NUMBER_REGEX = /^$|^([0-9]{10,15})$/;
